import { createIconSet } from '@expo/vector-icons';
import glyphMap from '~/../assets/fonts/FontAwesome/unicodesMap.json';
export default createIconSet(glyphMap, 'FontAwesome', require('~/../assets/fonts/FontAwesome/FontAwesome.ttf'));
